import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/')({
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { isInternalRole },
    } = context;

    const isAllowed = Boolean(isInternalRole);
    context.validatePermissions({ isAllowed, preload });
  },
});
